/* Padel unified badge rail + expected-date refresh (draft theme only). One script for Padel Offers cards and standard
   theme cards; guarded, so repeated script tags, AJAX grid swaps and Theme Editor reloads never add a second timer.

   Rail (slot 2 of [data-po-sig]): merchandising labels rotate one at a time (subtle vertical slide + fade, CSS), every
   ~3.5–4 s (data-int). A single label is static. Rotation pauses on desktop hover, keyboard focus, touch (5 s), hidden
   tabs and while off screen, and resumes from the REMAINING time. Reduced motion: the top-priority label, static.
   Priority: Best Seller → New → Weekend Deal → Price Drop → Selling Fast → the rest (merchant order).
   The active label is remembered per product, so filtering, sorting, Load more or a re-render never restart a rail.
   Padel Offers cards (card-mark layout, snippets/padel-outlet-card): theme labels become rating-row tags; every
   [data-rotate] group (tags, code / gift slot) rotates together every 2.2s on this script's single timer; Best Seller
   becomes the card's spine strip.

   Expected dates are rendered by Liquid (snippets/padel-delivery-dates: the theme's cutoff + business-day rules). When a
   cached page is viewed after the render's day or cutoff state changed, the same rules are re-run here (Asia/Dubai,
   cutoff at or after HHMM; express / standard count calendar days, global skips Sunday and counts Saturday; "tomorrow" only from 06:00 until the cutoff) so no stale promise is
   shown; one boundary timer moves an open page across 06:00 / the cutoff / midnight. */
(function () {
  if (window.poRail) return;
  var HEAD = ['new', 'weekend', 'pricedrop', 'selling'];
  var IDS = { 'text_label_jETVc9': 'new', 'text_label_poBest1': 'best', 'text-label': 'selling', 'text_label_eXBTpQ': 'weekend', 'text_label_k8XrnJ': 'weekend', 'text_label_3hjMqD': 'pricedrop', 'preorder_label_dLjeV4': 'preorder', 'sale-label': 'sale', 'sold-out-label': 'soldout' };
  var TYPES = { 'preorder-label': 'preorder', 'sale-label': 'sale', 'sold-out-label': 'soldout' };
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 3.2l2.7 5.6 6.1.8-4.5 4.2 1.1 6-5.4-2.9-5.4 2.9 1.1-6-4.5-4.2 6.1-.8z"/></svg>';
  var mem = {}, seen = new Set();
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)'), FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
  var IO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); }); }) : null;
  function cardOf(el) { return el.closest('[data-po-card]') || el.closest('.product-card__wrapper') || el.closest('[data-po-mr]'); }
  function pidOf(rail) { var row = rail.closest('[data-pid]'); return row ? row.getAttribute('data-pid') || '' : ''; }
  function idOf(li) { return (li.getAttribute('data-k') || '') + '|' + li.textContent.trim().slice(0, 40); }
  function dict(rail) { if (rail.__poT) return rail.__poT; try { rail.__poT = JSON.parse(rail.getAttribute('data-po-t') || '{}'); } catch (e) { rail.__poT = {}; } return rail.__poT; }
  function rank(rail, k) { var h = HEAD.indexOf(k); if (h >= 0) return h; var pri = (rail.getAttribute('data-pri') || '').split(','); var r = pri.indexOf(k); return r < 0 ? 999 : 10 + r; }
  function isStatic(rail) { return rail.getAttribute('data-rot') === '0' || RM.matches; }
  function sr(rail) {
    var items = rail.querySelectorAll('.po-rail__item'), out = rail.querySelector('[data-po-rail-sr]'), list = rail.querySelector('.po-rail__list');
    rail.hidden = !items.length;
    var row = rail.closest('[data-po-mr]'); if (row) row.classList.toggle('has-merch', !!items.length);
    if (list) list.setAttribute('aria-hidden', 'true');
    if (out) out.textContent = Array.prototype.map.call(items, function (i) { return (i.querySelector('.po-sig__ml') || i).textContent.replace(/\s+/g, ' ').trim(); }).filter(Boolean).join('. ');
  }
  // A label is shown only when it is fully visible in the merchandising slot (concise forms come from CSS container
  // queries); a label that cannot fit is skipped by the rotation instead of being clipped.
  function fits(rail, li) {
    var c = li && li.firstElementChild; if (!c) return true; var w = rail.clientWidth + 1;
    c.classList.remove('is-short'); if (c.scrollWidth <= w) return true;
    if (c.querySelector('.po-sig__ms')) { c.classList.add('is-short'); if (c.scrollWidth <= w) return true; c.classList.remove('is-short'); }
    return false;
  }
  function firstFit(rail, items, from) { for (var n = 0; n < items.length; n++) { var i = items[(from + n) % items.length]; if (fits(rail, i)) return i; } return null; }
  var RO = 'ResizeObserver' in window ? new ResizeObserver(function (es) { es.forEach(function (e) { e.target.__poDirty = true; }); }) : null;
  // Concise text for the server-rendered clothing badge (the theme labels get theirs in chip()).
  function shortCt(rail) {
    var s = dict(rail).clothing_s;
    Array.prototype.forEach.call(rail.querySelectorAll('[data-po-ct-badge]:not([data-po-sh])'), function (b) {
      b.setAttribute('data-po-sh', ''); if (!s) return;
      var full = b.textContent.trim(); b.title = full; b.textContent = '';
      var a = document.createElement('span'); a.className = 'po-sig__ml'; a.textContent = full;
      var z = document.createElement('span'); z.className = 'po-sig__ms'; z.textContent = s;
      b.appendChild(a); b.appendChild(z);
    });
  }
  function set(rail, li, animate) {
    var cur = rail.querySelector('.po-rail__item.is-active');
    if (!li) { if (cur) cur.classList.remove('is-active'); rail.classList.add('is-none'); return; } // nothing fits: no badge
    rail.classList.remove('is-none');
    if (cur === li) return;
    if (cur) { cur.classList.remove('is-active'); if (animate) { cur.classList.add('is-leaving'); setTimeout(function () { cur.classList.remove('is-leaving'); }, 300); } }
    li.classList.add('is-active');
    var pid = pidOf(rail); if (pid) mem[pid] = idOf(li);
  }
  function init(rail) {
    if (rail.__poRail) return;
    rail.__poRail = { next: 0, paused: 0, hold: 0 };
    shortCt(rail);
    sr(rail);
    var items = rail.querySelectorAll('.po-rail__item'), pid = pidOf(rail), want = pid && mem[pid], pick = items.length ? firstFit(rail, items, 0) : null;
    if (want && !isStatic(rail)) Array.prototype.forEach.call(items, function (i) { if (idOf(i) === want && fits(rail, i)) pick = i; });
    Array.prototype.forEach.call(items, function (i) { i.classList.toggle('is-active', i === pick); });
    var card = cardOf(rail);
    if (card && !card.__poTouch) { card.__poTouch = true; card.addEventListener('touchstart', function () { var r = card.querySelector('[data-po-rail]'); if (r && r.__poRail) r.__poRail.hold = Date.now() + 5000; }, { passive: true }); }
    if (IO) IO.observe(rail); else seen.add(rail);
    if (RO) RO.observe(rail);
    if (!pick && items.length) rail.classList.add('is-none');
  }
  // One normalized merchandising chip (identical geometry for every label; colour by type).
  function chip(rail, key, text) {
    var t = dict(rail), label = (t[key] || text || '').replace(/\s+/g, ' ').trim(), short = t[key + '_s'] || '';
    if (!label) return null;
    var s = document.createElement('span'); s.className = 'po-sig__m po-sig__m--' + key; s.title = label;
    s.innerHTML = (key === 'best' ? STAR : '') + '<span class="po-sig__ml"></span>' + (short ? '<span class="po-sig__ms"></span>' : '');
    s.querySelector('.po-sig__ml').textContent = label;
    if (short) s.querySelector('.po-sig__ms').textContent = short;
    return s;
  }
  function insert(rail, key, el) {
    if (!rail || !el) return;
    init(rail);
    if (rail.querySelector('.po-rail__item[data-k="' + key + '"]') && key !== 'other' && key !== 'custom' && key.indexOf('feature') !== 0) return;
    var li = document.createElement('li'); li.className = 'po-rail__item'; li.setAttribute('data-k', key); li.setAttribute('data-a', 's'); li.appendChild(el);
    var list = rail.querySelector('.po-rail__list'), before = null;
    Array.prototype.some.call(list.children, function (x) { if (rank(rail, x.getAttribute('data-k')) > rank(rail, key)) { before = x; return true; } return false; });
    list.insertBefore(li, before);
    sr(rail);
    var pid = pidOf(rail);
    if (!rail.querySelector('.po-rail__item.is-active') || isStatic(rail)) set(rail, firstFit(rail, list.children, 0), false);
    else if (pid && mem[pid] === idOf(li)) set(rail, li, false);
  }
  // Best Seller / New from the theme's Product labels and badges data (aside group; Best Seller is data-only).
  var sets = null;
  function labelSets() {
    if (sets) return sets;
    var s = { best: {}, new: {} }, any = false;
    Array.prototype.forEach.call(document.querySelectorAll('.x-badges-block-data'), function (d) {
      var j; try { j = JSON.parse(d.getAttribute('x-badges-block-data')); } catch (e) { return; }
      var k = IDS[j.id]; if ((k !== 'new' && k !== 'best') || j.enable === false || !j.settings) return;
      (j.settings.applied_products || []).forEach(function (p) { s[k][String(p)] = true; }); any = true;
    });
    if (any || document.readyState === 'complete') sets = s;
    return sets;
  }
  var blockTypes = null;
  function keyOf(badge) {
    if (!blockTypes) { blockTypes = {}; Array.prototype.forEach.call(document.querySelectorAll('.x-badges-block-data'), function (d) { try { var j = JSON.parse(d.getAttribute('x-badges-block-data')); blockTypes[j.id] = j.type; } catch (e) {} }); }
    var id = (badge.className.split(/\s+/)[0] || '').replace(/^x-badge-/, '');
    return IDS[id] || TYPES[blockTypes[id]] || 'other';
  }
  // Theme labels rendered by the theme's xLabelsAndBadges store → rail chips. Sale ("Save Dhs. X", the % says it) and the
  // theme Sold out label are never moved; image overlays keep only the discount %.
  // Padel Offers card (card-mark layout): merchandising tags live in the rating row ([data-po-tags], one shared grid
  // cell; order deal → New → Selling fast → highlight labels, max 3) and Best Seller is the card's frame + spine strip.
  var TORD = { weekend: 0, pricedrop: 0, 'new': 1, selling: 2, feature: 3 };
  var AR = (document.documentElement.lang || '').indexOf('ar') === 0;
  function ptx(card) { if (card.__poT) return card.__poT; try { card.__poT = JSON.parse(card.getAttribute('data-po-t') || '{}'); } catch (e) { card.__poT = {}; } return card.__poT; }
  function ord(x) { var k = x.getAttribute('data-k'); return k in TORD ? TORD[k] : 9; }
  function tag(card, key, text) {
    // A sold-out card shows only its server-rendered "Sold out" tag.
    var g = card.querySelector('[data-po-tags]'); if (!g || card.classList.contains('is-soldout') || !(key in TORD) || g.querySelector('[data-k="' + key + '"]')) return;
    var label = (ptx(card)[key] || text || '').replace(/\s+/g, ' ').trim(); if (!label) return;
    if (!AR) label = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
    var s = document.createElement('span'); s.className = 'po-tag ob-rot' + (key === 'weekend' || key === 'pricedrop' ? ' po-tag--deal' : ''); s.setAttribute('data-k', key); s.textContent = label;
    var before = null; Array.prototype.some.call(g.children, function (x) { if (ord(x) > TORD[key]) { before = x; return true; } return false; });
    g.insertBefore(s, before);
    while (g.children.length > 3) g.removeChild(g.lastElementChild);
  }
  function mark(card) {
    if (!card || card.classList.contains('is-soldout')) return;
    card.classList.add('po-card--best');
    var media = card.querySelector('.po-card__media'); if (!media || media.querySelector('.po-spine')) return;
    var lbl = (ptx(card).best || '').trim(); if (!lbl) return;
    var t = lbl, s = document.createElement('div'), sp = document.createElement('span');
    s.className = 'po-spine'; s.setAttribute('role', 'img'); s.setAttribute('aria-label', t);
    sp.className = 'po-spine__t'; sp.setAttribute('aria-hidden', 'true'); sp.textContent = t; s.appendChild(sp); media.appendChild(s);
  }
  // One shared rotation for every [data-rotate] group on the page (rating-row tags and the code / gift slot), driven by
  // this script's single timer: all groups flip together every 2.2s; groups added later (AJAX grids, section reloads)
  // join on the next tick; a group with one .ob-rot child shows it and never changes. Reduced motion: first child only
  // (the code row when a slot holds both).
  var TAG_INT = 2200, tagI = 0, tagNext = 0;
  function tagsTick(now) {
    var gs = document.querySelectorAll('[data-rotate]'); if (!gs.length) return;
    var still = RM.matches, adv = false;
    if (!still) { if (!tagNext) tagNext = now + TAG_INT; else if (now >= tagNext) { tagI++; tagNext = now + TAG_INT; adv = true; } }
    gs.forEach(function (g) {
      var t = g.querySelectorAll(':scope > .ob-rot'), n = t.length; if (!n) return;
      var on = g.querySelector('.is-on');
      if (!on) { t[still ? 0 : tagI % n].classList.add('is-on'); return; }
      if (adv && n > 1) { var nx = t[tagI % n]; if (nx !== on) { on.classList.remove('is-on'); nx.classList.add('is-on'); } }
    });
    // Apparel multi-buy slots (snippets/padel-clothing-tier part 'mb'): one tier step per tick of this same rotation,
    // every card in sync (shared tagI); the badge pops for 260ms. Reduced motion: never stepped (CSS shows the static
    // version). Modules added later join on the next tick.
    if (adv) document.querySelectorAll('[data-po-mb]').forEach(function (m) {
      var k = Math.min(3, parseInt(m.getAttribute('data-n'), 10) || 3);
      m.setAttribute('data-step', String(tagI % k));
      m.classList.add('is-pop'); clearTimeout(m.__poPop); m.__poPop = setTimeout(function () { m.classList.remove('is-pop'); }, 260);
    });
  }
  function route(card, badges) {
    if (card.querySelector('[data-po-tags]')) {
      Array.prototype.forEach.call(badges, function (b) {
        if (b.__poRouted) return; b.__poRouted = true;
        var key = keyOf(b); if (key === 'sale' || key === 'soldout') return;
        if (key === 'best') mark(card); else tag(card, key, b.textContent);
        b.classList.add('po-tc-moved');
      });
      return;
    }
    var rail = card.querySelector('[data-po-mr] [data-po-rail]'); if (!rail) return;
    Array.prototype.forEach.call(badges, function (b) {
      if (b.__poRouted) return; b.__poRouted = true;
      var key = keyOf(b); if (key === 'sale' || key === 'soldout') return;
      if (key === 'best') { ribbon(card, rail, b.textContent); b.classList.add('po-tc-moved'); return; }
      var c = chip(rail, key, b.textContent); if (c) insert(rail, key, c);
      b.classList.add('po-tc-moved');
    });
  }
  // Best Seller (round 4 final): a dark-green ribbon at the image's top start on purchasable cards (never in the rotating
  // slot; SOLD OUT has priority because sold-out cards have no merchandising slot at all).
  function ribbon(card, rail, text) {
    if (!card || card.classList.contains('is-soldout') || card.querySelector('.po-tc-so')) return;
    var media = card.querySelector('.po-card__media') || card.querySelector('.product-card__image-container');
    if (!media || media.querySelector('.po-rb')) return;
    var label = (dict(rail).best || text || '').replace(/\s+/g, ' ').trim(); if (!label) return;
    var r = document.createElement('span'); r.className = 'po-rb'; r.textContent = label; media.appendChild(r);
  }
  window.poPlaceLabels = function (host) {
    var card = host && host.closest && host.closest('[data-po-card]'); if (!card) return;
    if (!card.classList.contains('is-soldout')) route(card, host.querySelectorAll('.x-badge-container'));
    host.innerHTML = ''; host.setAttribute('data-po-done', '');
  };
  // Sold-out Padel theme card (marker .po-tc-so): the theme's cart button is only styled as unavailable; make it a real
  // disabled control so a click or Enter can never send a cart request. Quick View stays active.
  var SO_ADD = '.product-card__wrapper:has(.po-tc-so) .product-card__widget button[name="add"]';
  function soldOut() {
    try { document.querySelectorAll(SO_ADD + ':not([data-po-dis])').forEach(function (b) { b.setAttribute('data-po-dis', ''); b.disabled = true; b.setAttribute('aria-disabled', 'true'); }); } catch (e) {}
  }
  function block(e) {
    var t = e.target; if (!t || !t.closest) return;
    var hit = null; try { hit = e.type === 'submit' ? (t.closest('.product-card__wrapper') && t.closest('.product-card__wrapper').querySelector('.po-tc-so') && t.closest('.product-card__widget')) : t.closest(SO_ADD); } catch (x) {}
    if (hit) { e.preventDefault(); e.stopImmediatePropagation(); }
  }
  document.addEventListener('click', block, true);
  document.addEventListener('submit', block, true);
  function fill() {
    soldOut();
    // Hosts the theme already rendered before this script loaded.
    document.querySelectorAll('.po-tl:not([data-po-done])').forEach(function (h) { if (h.querySelector('.x-badge-container')) window.poPlaceLabels(h); });
    var s = labelSets();
    // Padel Offers cards: the theme's data-only Best Seller / New lists → frame + spine / New tag.
    if (s) document.querySelectorAll('[data-po-card][data-pid]:not([data-po-sf])').forEach(function (card) {
      if (!card.querySelector('[data-po-tags]')) return;
      card.setAttribute('data-po-sf', '');
      var pid = card.getAttribute('data-pid');
      if (s.best[pid]) mark(card);
      if (s['new'][pid]) tag(card, 'new', '');
    });
    document.querySelectorAll('[data-po-mr]:not([data-po-sf])').forEach(function (row) {
      var rail = row.querySelector('[data-po-rail]'); if (!rail || !s) return;
      row.setAttribute('data-po-sf', '');
      init(rail);
      var pid = row.getAttribute('data-pid');
      if (s.best[pid]) ribbon(row.closest('[data-po-card]') || row.closest('.product-card__wrapper'), rail, '');
      if (s.new[pid]) { var c = chip(rail, 'new', ''); if (c) insert(rail, 'new', c); }
      // Standard theme card: harvest its overlay labels (they render asynchronously).
      var card = row.closest('.product-card__wrapper');
      if (card && !card.__poObs) {
        card.__poObs = true;
        var harvest = function () { route(card, card.querySelectorAll('.label-container .x-badge-container')); };
        harvest();
        new MutationObserver(harvest).observe(card, { childList: true, subtree: true });
      }
    });
  }
  // Expected-date refresh for cached pages (same rules as snippets/padel-delivery-dates).
  function dubai() {
    var p = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Dubai', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var y = +p.year, m = +p.month, d = +p.day, hh = p.hour.replace('24', '00'), hm = +(hh + p.minute);
    return { y: y, m: m, d: d, hm: hm, sec: +hh * 3600 + +p.minute * 60 + +p.second, dow: new Date(Date.UTC(y, m - 1, d)).getUTCDay(), st: '' + y + p.month + p.day };
  }
  // Phase of the shop day: 0 before 06:00 (exact dates, no "tomorrow"), 1 from 06:00 until the cutoff ("tomorrow" allowed
  // when the minimum date is the next calendar day), 2 at or after the cutoff (+1 business day, never "tomorrow").
  function phase(hm, cut) { return hm >= cut ? 2 : hm < 600 ? 0 : 1; }
  function cal(days, dow) { var c = 0, r = days; if (r <= 0) return 0; for (var i = 0; i < 60; i++) { c++; var w = (dow + c) % 7; if (w !== 0) r--; if (r <= 0) break; } return c; }
  function fmt(o, mode, n, ph) {
    // ex: the class counts calendar days and may read "tomorrow" ("cal" from snippets/padel-delivery-dates' class table;
    // pages cached before it existed fall back to the calendar classes by name).
    var after = ph === 2 ? 1 : 0, a = o.min + after, b = o.max + after, ex = typeof o.cal === 'boolean' ? o.cal : (o.dc === 'express' || o.dc === 'standard'), c1 = ex ? Math.max(0, a) : cal(a, n.dow), c2 = ex ? Math.max(0, b) : cal(b, n.dow);
    if (c1 <= 0 || c2 < c1) return '';
    var base = Date.UTC(n.y, n.m - 1, n.d), d1 = new Date(base + c1 * 864e5), d2 = new Date(base + c2 * 864e5);
    var ar = o.lang === 'ar', L = ar ? '⁦' : '', R = ar ? '⁩' : '';
    var mf = new Intl.DateTimeFormat(ar ? 'ar' : (o.lang || 'en'), { month: (mode === 'card' && o.lang === 'en') ? 'short' : 'long', timeZone: 'UTC' });
    var m1 = mf.format(d1), m2 = mf.format(d2), D1 = d1.getUTCDate(), D2 = d2.getUTCDate();
    if (ex && ph === 1 && c1 === 1) { var tom = mode === 'card' ? o.tomS : o.tomL; return c2 === c1 ? tom : tom + '–' + L + D2 + R + ' ' + m2; }
    if (d1.getUTCMonth() === d2.getUTCMonth()) return D1 === D2 ? L + D1 + R + ' ' + m1 : L + D1 + '–' + D2 + R + ' ' + m1;
    return L + D1 + R + ' ' + m1 + ' – ' + L + D2 + R + ' ' + m2;
  }
  function eta(sel) {
    var n = null;
    document.querySelectorAll(sel || '[data-po-eta]').forEach(function (el) {
      el.setAttribute('data-po-ec', '');
      var o = el.__poEta; if (!o) { try { o = el.__poEta = JSON.parse(el.getAttribute('data-po-eta')); } catch (e) { return; } }
      n = n || dubai();
      var ph = phase(n.hm, o.cut), st = n.st + '-' + ph;
      if (st === o.st) return;
      var mode = el.getAttribute('data-po-eta-mode'), shortTxt = fmt(o, 'card', n, ph), longTxt = fmt(o, 'long', n, ph);
      if (!shortTxt || !longTxt) return;
      if (mode === 'card') {
        var dt = el.querySelector('[data-po-eta-dt]'), s = el.querySelector('[data-po-eta-sr]');
        if (dt) dt.textContent = shortTxt;
        if (s) s.textContent = ': ' + o.exL.replace('%D%', longTxt);
        if (el.title) el.title = el.title.split(' · ')[0] + ' · ' + o.exL.replace('%D%', longTxt);
      } else el.textContent = o.exL.replace('%D%', longTxt);
      o.st = st;
    });
  }
  // One boundary timer for the whole page (no polling): it fires at the next 06:00, cutoff or midnight in Asia/Dubai,
  // refreshes every expected date and schedules itself again. Re-armed when the tab becomes visible (sleeping devices
  // delay timers). Chips inserted later (AJAX grids, Quick View, editor reloads) are checked once when they appear.
  var bTimer = 0;
  function cutMin() { var c = 1200; var el = document.querySelector('[data-po-eta]'); if (el) { try { c = (el.__poEta || JSON.parse(el.getAttribute('data-po-eta'))).cut || 1200; } catch (e) {} } return Math.floor(c / 100) * 60 + c % 100; }
  function arm() {
    clearTimeout(bTimer);
    var n = dubai(), s = n.sec, marks = [360 * 60, cutMin() * 60, 86400], next = 86400;
    for (var i = 0; i < marks.length; i++) if (marks[i] > s) { next = marks[i]; break; }
    bTimer = setTimeout(function () { eta(); arm(); }, (next - s) * 1000 + 400);
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { eta(); arm(); } });
  function tick() {
    var now = Date.now();
    fill();
    tagsTick(now);
    if (document.querySelector('[data-po-eta]:not([data-po-ec])')) eta('[data-po-eta]:not([data-po-ec])');
    var hover = FINE.matches;
    document.querySelectorAll('[data-po-rail]').forEach(function (rail, i) {
      init(rail);
      var st = rail.__poRail, items = rail.querySelectorAll('.po-rail__item');
      // Width changed (resize, rotation, editor): keep only a label that fully fits (full text, else concise, else skip).
      if (rail.__poDirty && items.length) { rail.__poDirty = false; var ac = rail.querySelector('.po-rail__item.is-active'); if (!ac || !fits(rail, ac)) set(rail, firstFit(rail, items, 0), false); }
      if (rail.hidden || items.length < 2 || isStatic(rail)) return;
      var every = parseInt(rail.getAttribute('data-int'), 10) || 3800;
      if (!st.next) { st.next = now + every + (i % 4) * 160; return; }
      var card = cardOf(rail);
      var held = document.hidden || !seen.has(rail) || st.hold > now || (rail.getAttribute('data-pause') !== '0' && card && ((hover && card.matches(':hover')) || card.matches(':focus-within')));
      if (held) { if (!st.paused) st.paused = now; return; }
      if (st.paused) { st.next += now - st.paused; st.paused = 0; }
      if (now < st.next) return;
      var cur = rail.querySelector('.po-rail__item.is-active'), idx = Array.prototype.indexOf.call(items, cur);
      set(rail, firstFit(rail, items, idx + 1), true);
      st.next = now + every;
    });
    offers(now, hover);
  }
  // Best Price / free-gift panel (snippets/padel-offer-code, gift-qualifying EXTRA5 rackets on Padel Offers cards): one
  // fixed-size panel alternating state A (Best Price) and state B (gift), every 4 s, on the same shared tick. Pauses on
  // card hover, focus inside the card, hidden tab and off screen; resumes from the remaining time. Reduced motion (and no
  // JS) never rotates: CSS shows the combined static panel. State A holds the copy button; focus entering the card brings
  // state A back so the button stays in the tab order. Visual changes are never announced (no live region).
  var OFF_INT = 4000;
  function offSet(p, i, animate) {
    var s = p.querySelectorAll('.po-bo__s'), cur = p.querySelector('.po-bo__s.is-active'), li = s[i];
    if (!li || cur === li) return;
    if (cur) { cur.classList.remove('is-active'); if (animate) { cur.classList.add('is-leaving'); setTimeout(function () { cur.classList.remove('is-leaving'); }, 300); } }
    li.classList.add('is-active'); p.setAttribute('data-po-state', i ? 'gift' : 'best');
  }
  function offers(now, hover) {
    document.querySelectorAll('[data-po-offer]').forEach(function (p, i) {
      var de = document.documentElement;
      if (RM.matches || de.hasAttribute('data-po-nogift') || de.classList.contains('po-campaign-ended')) { p.removeAttribute('data-po-offer-on'); offSet(p, 0, false); if (p.__poOff) p.__poOff.next = 0; return; }
      if (!p.__poOff) { p.__poOff = { next: 0, paused: 0 }; if (IO) IO.observe(p); else seen.add(p); }
      p.setAttribute('data-po-offer-on', '');
      var st = p.__poOff;
      if (!st.next) { st.next = now + OFF_INT + (i % 4) * 200; return; }
      var card = cardOf(p);
      var held = document.hidden || !seen.has(p) || (card && ((hover && card.matches(':hover')) || card.matches(':focus-within')));
      if (held) { if (!st.paused) st.paused = now; return; }
      if (st.paused) { st.next += now - st.paused; st.paused = 0; }
      if (now < st.next) return;
      offSet(p, p.getAttribute('data-po-state') === 'gift' ? 0 : 1, true);
      st.next = now + OFF_INT;
    });
  }
  document.addEventListener('focusin', function (e) {
    var card = e.target && e.target.closest && (e.target.closest('[data-po-card]') || e.target.closest('.product-card__wrapper'));
    var p = card && card.querySelector('[data-po-offer]');
    if (p && p.getAttribute('data-po-state') === 'gift') { offSet(p, 0, false); if (p.__poOff) { p.__poOff.next = Date.now() + OFF_INT; p.__poOff.paused = Date.now(); } }
  });
  window.poRail = { insert: insert, chip: chip, init: init, fill: fill, eta: eta, _fmt: fmt, _cal: cal, _phase: phase, _timer: function () { return bTimer; } };
  window.poRailInsert = function (rail, key, el) { insert(rail, key, el); };
  setInterval(tick, 250);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { eta(); arm(); tick(); }); else { eta(); arm(); tick(); }
})();
